globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

appCustomerSpace.LimitlessPlugins.Validation = (function(){

    Validation.selector = '.input-to-validate';

    Validation.errors = function({ $form = undefined, errors = {}} = {}) {
        $.each(errors, function(name, message) {
            var $input = ($form || $('body')).find(Validation.selector + '[name*="' + name + '"]').first(),
                $formGroup = $input ? Validation.getFormGroupWithLabel($input.closest('.form-group')) : undefined;

            if($input && $formGroup) {
                if(!$formGroup.hasClass('has-error')) {
                    $formGroup.removeClass('has-success').addClass('has-error');
                }
                if($feedBack = $formGroup.find('.form-control-feedback')) {
                    $feedBack.find('i').hide().end()
                             .find('i.icon-checkmark-circle').remove().end()
                             .append('<i class="icon-cancel-circle2">');
                }
                if(!$formGroup.find('.help-block').length) {
                    $formGroup.append('<span class="help-block">' + message + '</span>');
                }
            }

        });
    }

    Validation.success = function({ $form = undefined, inputs_name = []} = {}) {
        $.each(inputs_name, function(i, name){
            var $input = ($form || $('body')).find(Validation.selector + '[name*="' + name + '"]').first(),
                $formGroup = $input ? Validation.getFormGroupWithLabel($input.closest('.form-group')) : undefined;

            if($input && $formGroup) {
                if(['text', 'email', 'password', 'date', 'time', 'select'].includes($input.prop('type'))) {
                    if($formGroup.hasClass('has-error')) {
                        $formGroup.removeClass('has-error').addClass('has-success').find('.help-block').remove();
                        if($feedBack = $formGroup.find('.form-control-feedback')) {
                            $feedBack.find('i.icon-cancel-circle2').remove().end().append('<i class="icon-checkmark-circle">');
                        }
                    }
                } else {
                    Validation.reset({$form: $form, inputs_name: inputs_name});
                }
            }

        })
    }

    Validation.reset = function({ $form = undefined, inputs_name = []} = {}) {
        $.each(inputs_name, function(i, name){
            var $input = ($form || $('body')).find(Validation.selector + '[name*="' + name + '"]').first(),
                $formGroup = $input ? Validation.getFormGroupWithLabel($input.closest('.form-group')) : undefined;

            if($input && $formGroup) {
                $formGroup.removeClass('has-error has-success').find('.help-block').remove();
                if($feedBack = $formGroup.find('.form-control-feedback')) {
                    $feedBack.find('i.icon-cancel-circle2').remove().end()
                             .find('i.icon-checkmark-circle').remove().end()
                             .find('i').show();
                }
            }

        })
    }

    Validation.getFormGroupWithLabel = function($formGroup){
        if(!$formGroup.length) return;

        if($formGroup.find('> label').length) {
            return $formGroup;
        } else {
            if($formGroupAncestor = $formGroup.closest('.form-group')) {
                return Validation.getFormGroupWithLabel($formGroupAncestor);
            } else {
                return;
            }
        }
    }

    function Validation() {}
    return Validation;

})();
